module.exports = __webpack_public_path__ + "static/media/block1-background-alt.ee84c7d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/home/block1-background-alt.jpg
// module id = 115
// module chunks = 0